import { Component, Input, OnInit } from '@angular/core';
import { Menu, SectionMenu } from '../../models/menu.model';
import { MenuService } from '../../services/menu.service';

@Component({
    selector: 'app-item-list-additions',
    templateUrl: './item-list-additions.component.html',
    styleUrls: ['./item-list-additions.component.scss'],
    standalone: false
})
export class ItemListAdditionsComponent implements OnInit {
  /**
   * Informacion del menu seleccionado
   */
  @Input() menu: Menu = {} as Menu;
  /**
   * Listado de productos
   */
  @Input() section: SectionMenu = {} as SectionMenu;
  /**
   * Indica el idioma seleccionado
   */
  language: string | undefined;
  constructor(
    private menuService: MenuService
  ) {
  }

  ngOnInit(): void {
    this.menuService.language$.subscribe((lang: string) => {
      this.language = lang;
    });
  }

}
